import React from 'react';
import { Toast } from 'snacks-design-system';
interface componentProps {
  children: React.ReactNode;
  icon?: React.ReactNode | null;
  mode?: 'regular' | 'info' | 'warning' | 'success' | 'error';
  align?: 't-l' | 't-c' | 't-r' | 'b-l' | 'b-c' | 'b-r';
  isOpen?: boolean;
  autoCloseTimeout?: number;
  showIcon?: boolean;
  primaryActionButtonProps?: any;
  secondaryActionButtonProps?: any;
  modCompact?: boolean;
  modFluid?: boolean;
  onClose?: () => void;
  dataSdtrack?: string;
  qaSelector?: string;
}
const PIEToast = (props: componentProps) => {
  return <Toast {...props} />;
};

export default PIEToast;
